import { mapGetters, mapActions } from 'vuex'
import MarkdownEditor from '@/components/MarkdownEditor/MarkdownEditor.vue'

export default {
  name: 'ArticleShared',
  data () {
    return {
      isLoading: { article: false },
      title: null,
      finalDraft: ''
    }
  },
  async mounted () {
    await this.loadData()
  },
  watch: {
    async $route () {
      await this.loadData()
    }
  },
  computed: {
    ...mapGetters([
      'article'
    ]),
    articleId () {
      return parseInt(this.$route.params.articleId)
    },
    sharingKey () {
      return this.$route.params.sharingKey
    },
    contentplanId () {
      return parseInt(this.$route.params.contentplanId)
    }
  },
  methods: {
    ...mapActions([
      'articleGet'
    ]),
    async loadData () {
      this.isLoading.article = true
      try {
        await this.articleGet({ contentplanId: this.contentplanId, articleId: this.articleId, sharingKey: this.sharingKey })
      } catch (e) {
        console.error(e)
      }
      this.isLoading.article = false

      this.finalDraft = this.article?.final
      this.title = this.article?.title
      document.title = this.article?.title + ' | ContentGecko'
    }
  },
  components: { MarkdownEditor }
}
